import type { Parameters, UnknownParamsObject } from "../../common.ts";
import { omitPathParameters, replacePathParameters } from "../../utils";
import type { AxiosInstance, AxiosRequestConfig } from "axios";
import type * as InitializeCsrfCookie from "./paths/initializeCsrfCookie.ts";
import type * as LoginBrowser from "./paths/loginBrowser.ts";
import type * as GetAuthenticatedUser from "./paths/getAuthenticatedUser.ts";
import type * as LogoutBrowser from "./paths/logoutBrowser.ts";

export const getAuthOperations = (client: AxiosInstance) => {
  const initializeCsrfCookie = (
    parameters?: any,
    data?: any,
    config?: AxiosRequestConfig,
  ) => {
    const url = "/auth/csrf-cookie";
    return client.get<InitializeCsrfCookie.Responses.$200>(
      replacePathParameters(url, parameters),
      {
        params: omitPathParameters(parameters, url),
        data: data,
        ...config,
      },
    );
  };
  const loginBrowser = (
    parameters: any,
    data: LoginBrowser.RequestBody,
    config?: AxiosRequestConfig,
  ) => {
    const url = "/auth/login/browser";
    return client.post<LoginBrowser.Responses.$200>(
      replacePathParameters(url, parameters),
      data,
      {
        params: omitPathParameters(parameters, url),
        ...config,
      },
    );
  };
  const getAuthenticatedUser = (
    parameters: Parameters<UnknownParamsObject> | null,
    data?: any,
    config?: AxiosRequestConfig,
  ) => {
    const url = "/auth/user";
    return client.get<GetAuthenticatedUser.Responses.$200>(
      replacePathParameters(url, parameters),
      {
        params: omitPathParameters(parameters, url),
        data: data,
        ...config,
      },
    );
  };
  const logoutBrowser = (
    parameters: Parameters<UnknownParamsObject> | null,
    data?: any,
    config?: AxiosRequestConfig,
  ) => {
    const url = "/auth/logout/browser";
    return client.post<LogoutBrowser.Responses.$200>(
      replacePathParameters(url, parameters),
      data,
      {
        params: omitPathParameters(parameters, url),
        ...config,
      },
    );
  };
  return {
    initializeCsrfCookie,
    loginBrowser,
    getAuthenticatedUser,
    logoutBrowser,
  };
};
